import _0x187a56 from'./recaptcha-wrapper';import _0x214257 from'./recaptcha';export default _0x187a56;export{_0x214257 as ReCAPTCHA};